import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { Grid, Title } from '@mantine/core'
import { useEffect } from 'react'

import { useQueryGetUserBookingsSettings } from '@flecto/core/shared'
import { useTranslation } from '@flecto/translations'
import { CollapsibleCard, TimePickerInput } from '@flecto/ui'
import { formatDateString } from '@flecto/utils'

import { useBookingHourState } from '../../hooks/useBookingHourState'

export function SectionBookingHours() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_bookings' })

  const { data: userBookingsSettings } = useQueryGetUserBookingsSettings()

  const { setDefaultHour, default_end_hour, default_start_hour } =
    useBookingHourState()

  useEffect(() => {
    if (userBookingsSettings) {
      setDefaultHour(
        new Date(
          String(
            userBookingsSettings.default_booking_start_at ??
              '2000-01-01T00:00:00'
          ).replace('Z', '')
        ),
        'default_start_hour'
      )
      setDefaultHour(
        new Date(
          String(
            userBookingsSettings.default_booking_end_at ?? '2000-01-01T00:00:00'
          ).replace('Z', '')
        ),
        'default_end_hour'
      )
    }
  }, [userBookingsSettings])

  return (
    <>
      <Title order={4} mb='lg'>
        {t('preferences')}
      </Title>
      <CollapsibleCard opened>
        <CollapsibleCard.Title>
          {t('preferences_description')}
        </CollapsibleCard.Title>
        <CollapsibleCard.Description>
          {t('choose_hour')}
        </CollapsibleCard.Description>
        <CollapsibleCard.Icon withCircleBackground icon={faClock} />
        <CollapsibleCard.Content>
          <Grid gutter='lg'>
            <Grid.Col span={6} maw={200}>
              <TimePickerInput
                withAsterisk
                value={formatDateString({
                  date: default_start_hour.toISOString(),
                  variant: 'time-brief',
                })}
                label={t('start_booking')}
                onChange={(time) =>
                  time &&
                  setDefaultHour(
                    new Date(`2000-01-01T${time}:00`),
                    'default_start_hour'
                  )
                }
              />
            </Grid.Col>
            <Grid.Col span={6} maw={200}>
              <TimePickerInput
                withAsterisk
                label={t('end_booking')}
                value={formatDateString({
                  date: default_end_hour.toISOString(),
                  variant: 'time-brief',
                })}
                onChange={(time) =>
                  time &&
                  setDefaultHour(
                    new Date(`2000-01-01T${time}:00`),
                    'default_end_hour'
                  )
                }
              />
            </Grid.Col>
          </Grid>
        </CollapsibleCard.Content>
      </CollapsibleCard>
    </>
  )
}
